/* eslint-disable max-depth */
// only put action here if got problem with import cycle

import { dispatch } from '@redux/store';
import Api from '@helpers/api';
import { endpoints } from '@configs/endpoints';
// import { NEW_ASSETS_LIST } from '../assets';

export const apiGetCompanies = (token) => {
  dispatch({ type: 'companies/API_GET_COMPANIES' });
  Api({
    endpoint: endpoints.getCompaniesAssets(),
    token,
    onSuccess: response => {
      for (let i = 0; i < response.data.length; i++) {
        if (!!response.data[i].assets_details) {
          const assets = response.data[i].assets_details;

          for (let k = 0; k < assets.length; k++) {
            assets[k].latitude = parseFloat(assets[k].latitude);
            assets[k].longitude = parseFloat(assets[k].longitude);
            assets[k].company_id = response.data[i].id;
          }
          dispatch({ type: 'assets/NEW_ASSETS_LIST', data: assets });
        }
      }
      dispatch({ type: 'companies/API_GET_COMPANIES_SUCCESS', data: response.data });
    },
    onFail: () => {
      const error = 'Sorry, please try again later';
      dispatch({ type: 'companies/API_GET_COMPANIES_FAIL', error });
    },
  });
};
